import { withPrefix } from 'gatsby'

export default {
  metadata: {
    title: 'Transparent, flexible pricing to suit your business needs. - artificial',
    desc: `We believe in honest, flexible pricing. That's why we charge for our software on a transactional basis, based on your exact feature set and volume.`,
  },
  ArHeroHeader: {
    title: 'Pricing',
    description: 'Transparent, flexible pricing to suit your business needs.',
    cta: {
      label: 'Request a demo',
    },
    image: {
      alt: '',
      copyright: '',
      url: withPrefix('img/ArHeroHeaderPricing.png'),
    },
  },
  ArPostSimple: {
    title: 'The new standard in paying for world class insurance software',
    description: [
      'We believe pricing should be fairer and more transparent.',
      { tag: 'br' },
      { tag: 'br' },
      'Instead of significant up front spending, expensive upgrades and one-size-fits-all applications, we charge for our software on a transactional basis based on your exact feature set and volume.',
      { tag: 'br' },
      { tag: 'br' },
      'Fees are only charged on net written premium, so you never pay for what you don’t use, and we are always here to help your business grow.',
    ],
  },
  ArBenefits: {
    title: 'Included in our fees',
    description: 'Our prices cover customisation, upgrades and support alongside world-class software.',
    benefits: [
      {
        image: {
          url: withPrefix('img/ArPricingBenefits1.svg'),
        },
        title: 'Design',
        description: 'Fully whitelabelled - use your branding and not ours!',
      },
      {
        image: {
          url: withPrefix('img/ArPricingBenefits2.svg'),
        },
        title: 'Integrations',
        description: 'Integration with other systems as and when required',
      },
      {
        image: {
          url: withPrefix('img/ArPricingBenefits3.svg'),
        },
        title: 'Support',
        description: 'Our team are always here to support you and your business',
      },
      {
        image: {
          url: withPrefix('img/ArPricingBenefits4.svg'),
        },
        title: 'Infrastructure',
        description: 'AWS infrastructure with guaranteed uptimes',
      },
      {
        image: {
          url: withPrefix('img/ArPricingBenefits5.svg'),
        },
        title: 'Customisations',
        description: 'Customised software for your specific requirements',
      },
      {
        image: {
          url: withPrefix('img/ArPricingBenefits6.svg'),
        },
        title: 'Upgrades',
        description: 'The latest and greatest upgrades - and they’re always free',
      },
      {
        image: {
          url: withPrefix('img/ArPricingBenefits7.svg'),
        },
        title: 'Business Analysis',
        description: 'Everything you need for perfect integration and transition',
      },
      {
        image: {
          url: withPrefix('img/ArPricingBenefits8.svg'),
        },
        title: 'Project Management',
        description: 'Full support to help you switch seamlessly to our products',
      },
    ],
  },
}
